import firebase from 'firebase';

let app;

if(firebase.apps.length < 1) {
	app = firebase.initializeApp({
        apiKey: "AIzaSyCTNZMhzMc2UIQvV6fXJUhNUoqhyvdFmmg",
        authDomain: "open-soils-vr.firebaseapp.com",
        databaseURL: "https://open-soils-vr-default-rtdb.firebaseio.com",
        projectId: "open-soils-vr",
        storageBucket: "open-soils-vr.appspot.com",
        messagingSenderId: "35877875012",
        appId: "1:35877875012:web:dfd60cc0e0260c7a07bb11"
	})
}

firebase.auth().useDeviceLanguage();

export const db = firebase.firestore()
export const auth = firebase.auth()
export const provider = new firebase.auth.GoogleAuthProvider();

export default app;